//* This controller gets added onto pages that use recaptcha
//* It finds the fidden fields that it recaptcha creates
//* Then it adds some metadata to it so it passes WCAG validation checkers (eg. WAVE)

import ApplicationController from "../application_controller.js";

export default class extends ApplicationController  {
  static values = {
    espa: { type: Boolean, default: false },
  };

  connect() {
    this.log_function("connect");

    if(this.espaValue){
      this.boundFixRecaptcha = this.FixRecaptcha.bind(this);
      this.FixRecaptchaInterval = window.setInterval(this.boundFixRecaptcha, 1000);

      // const hiddenInputs = document.querySelectorAll("input[type=hidden]");
      // hiddenInputs.forEach(input => {
      //   input.removeAttribute("autocomplete");
      // });
    }
  }

  FixRecaptcha() {
    this.log_function("FixRecaptcha");

    const elements = document.getElementsByClassName("g-recaptcha-response");
    if (elements.length > 0) {
      for (let i = 0; i < elements.length; i++) {
        this.log_function("FixRecaptcha", `"Fixing WCAG on: ${elements[i]}`);
        elements[i].setAttribute("aria-labelledby", "g-recaptcha-response");
      }
      this.clearRecaptchaInterval();
    }
  }

  clearRecaptchaInterval() {
    this.log_function("clearRecaptchaInterval");

    if(this.FixRecaptchaInterval){
      clearInterval(this.FixRecaptchaInterval);
    }
  }

  disconnect(){
    this.log_function("disconnect");

    this.clearRecaptchaInterval();
  }
}
